import { Injectable } from '@angular/core';
import { Restangular } from 'ngx-restangular';
import { AppSettings } from 'src/app/app.settings';
import { MarketingArchiveStatusFilter } from '../../interfaces/campaigns/campaign.interface';
import {
  MarketingSequence,
  PostMarketingSequence,
} from '../../interfaces/campaigns/sequence.interface';

@Injectable({
  providedIn: 'root',
})
export class MarketingSequencesService {
  constructor(
    private baseRestAngular: Restangular,
    private restAngular: Restangular,
  ) {
    this.restAngular = this.getCustomRestAngular();
  }

  getCustomRestAngular() {
    return this.baseRestAngular.withConfig((RestangularConfigurer: any) => {
      RestangularConfigurer.setBaseUrl(AppSettings.getMarketingEndpoint());
    });
  }

  create(data: PostMarketingSequence): Promise<MarketingSequence> {
    return this.restAngular.one('sequences').customPOST(data).toPromise();
  }

  getAll(status: MarketingArchiveStatusFilter = 'active'): Promise<MarketingSequence[]> {
    return this.restAngular.all('sequences').getList({ status }).toPromise();
  }

  updateById(id: string, data: PostMarketingSequence): Promise<MarketingSequence> {
    return this.restAngular.one('sequences', id).customPUT(data).toPromise();
  }

  archiveById(id: string): Promise<void> {
    return this.restAngular.one('sequences', id).remove().toPromise();
  }
}
